import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import * as ApplicationStateActions from "@vp/data-access/application";
import { ApplicationErrorEvent } from "@vp/models";
import { AppInsightsEvent } from "@vp/shared/app-insights-proxy-service";

export const ON_INIT = "ngOnInit";
export const ON_DESTROY = "ngOnDestroy";

@Injectable({
  providedIn: "root"
})
export class LoggerService {
  constructor(private readonly store: Store) {}

  systemEvent(
    source: string,
    message: string,
    properties?: { [key: string]: any } | null | undefined
  ) {
    const systemEvent = new AppInsightsEvent({
      error: null,
      type: "event",
      source: source,
      message: message,
      properties: properties
    });

    this.store.dispatch(new ApplicationStateActions.EmitEvent(systemEvent, source));
  }

  errorEvent(error: any, source?: string, message?: string, properties?: { [key: string]: any }) {
    let appError: any;
    if (error instanceof HttpErrorResponse) {
      appError = ApplicationErrorEvent.fromHttpErrorResponse(error, source, message, properties);
    } else if (error instanceof AppInsightsEvent) {
      appError = AppInsightsEvent.fromAnyErrorResponse(error, message, properties);
    } else {
      appError = ApplicationErrorEvent.fromAnyErrorResponse(error, message, properties);
    }
    const _source = source ?? error.source ?? error.name ?? "unkonwn";

    this.store.dispatch(new ApplicationStateActions.EmitEvent(appError, _source));
  }
}
